<template>
  <div class="article-lists-wrap" :class="{ 'is-video': isVideoType }">
    <template v-if="articleList && articleList.length">
      <component
        :is="articleTypeComp[articleType]"
        v-for="item in articleList"
        :key="item.ID"
        :articleItemInfo="item"
        :showLikes="showLikes"
        :source="source || ''"
        class="article-item"
      ></component>
      <div class="load-more" v-if="hasMore" @click="loadMore">
        {{ getText("getMore") }}<span class="ico"></span>
      </div>
    </template>
    <p v-else class="no-tips">{{ getText("noArticle") }}</p>
  </div>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import ArticleItem from "@components/article/ArticleItem.vue";
import ArticleItemVideo from "@components/article/ArticleItemVideo.vue";
import { ArticleType } from "@config/article";
import { getText } from "@config/siteConfig";
const props = defineProps({
  articleList: {
    default: [],
  },
  noItemTips: {
    default: "",
  },
  articleType: {
    default: ArticleType.Article,
  },
  showLikes: {
    default: 0,
  },
  hasMore: {
    default: false,
  },
  finishLoadMore: {
    default: false,
  },
  source: {
    default: "",
  },
  moduleName: {
    default: "",
  },
});
const emits = defineEmits(["loadMore"]);
const articleTypeComp = {
  [ArticleType.Default]: ArticleItem,
  [ArticleType.Article]: ArticleItem,
  [ArticleType.Video]: ArticleItemVideo,
};

const isVideoType = computed(() => {
  return props.articleType == ArticleType.Video;
});

const loadMore = () => {
  clickButtonPoint({
    btnName: `more`,
    moduleName: props.moduleName,
  });
  emits("loadMore");
};
</script>
<style scoped lang="scss">
@import "@assets/scss/dimen.scss";
.article-lists-wrap {
  position: relative;
  width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
  margin-bottom: 150px;

  &.is-video {
    display: grid;
    grid-template-columns: repeat(2, 335px);
    grid-auto-flow: row;
    gap: 20px;
    justify-items: center;
    align-items: flex-start;
  }
  .no-tips {
    position: absolute;
    top: 100px;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
    width: 100%;
    font-size: $fzTitle;
    color: $itemcolor;
  }
  .load-more {
    position: absolute;
    bottom: -120px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 15px 63px;
    background: $layercolor;
    border: 1px solid $tipscolor;
    border-radius: 14px;
    width: max-content;
    margin: 0 auto;
    font-size: $fzSmall;

    .ico {
      display: block;
      margin-left: 5px;
      width: 23px;
      height: 15px;
      background: url("@assets/images/more.png") no-repeat;
      background-size: cover;
    }
  }
}

@media only screen and (min-height: 640px) and (orientation: landscape) {
  .article-lists-wrap {
    margin-bottom: calc(150px / $pcRate);

    &.is-video {
      grid-template-columns: repeat(2, calc(335px / $pcRate));
      gap: calc(20px / $pcRate);
    }
    .no-tips {
      font-size: $fzTitlePc;
    }
    .load-more {
      bottom: calc(-120px / $pcRate);
      padding: calc(15px / $pcRate) calc(63px / $pcRate);
      border-radius: calc(14px / $pcRate);
      font-size: $fzSmallPc;

      .ico {
        margin-left: calc(5px / $pcRate);
        width: calc(23px / $pcRate);
        height: calc(15px / $pcRate);
      }
    }
  }
}
</style>
